import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";

$.koVal = function(value) {
    var res = ko.utils.unwrapObservable(value);
    if (typeof value == "undefined")
        return null;
    return res;
};

function _build_grid_columns(model, custom) {
    var cols = [], is_custom = false, original_columns = model.columns.slice(0);
    if (custom && model.user_settings != null){
        cols = model.user_settings;
        is_custom = true;
    }else{
        cols = model.columns;
    }
    if (model.columns){
        var columns = $.map(cols, function(column,index) {
            if (is_custom){
                var found = false, len = original_columns.length, i = 0;
                while(!found && i < len){
                    if (original_columns[i] && original_columns[i].field == column.field){
                        column.column = original_columns[i].column;
                        column.custom_formatter = original_columns[i].custom_formatter;
                        column.editable = original_columns[i].editable;
                        column.editor = original_columns[i].editor;
                        column.formatter = original_columns[i].formatter;
                        column.hidden = original_columns[i].hidden;
                        found = true;
                        column.valid = true;
                        original_columns.splice(i, 1);
                    }else{
                        column.valid = false;
                        i++;
                    }
                }
            }else{
                column.valid = true;
            }
            if (column.valid && column && !column.hidden) {
                var col = {
                    "field":column.field,
                    "id":column.id ? column.id : "col_"+index,
                    "resizable":true,
                    "sortable":true,
                    "selectable":true,
                    "name":column.column,
                    "sorted":column.sorted ? true : false,
                    "sort_direction":column.sort_direction,
                    "filter_default_val":column.filter_default_val || null,
                    "filter_op":column.filter_op,
                    "filter_control":column.filter_control,
                    "filter_field":column.filter_field || column.field,
                    "width":1*(column.width || 100),
                    "header": {menu: {items: [{iconCssClass: "fa fa-sort-desc",title: "Hide Column",command: "hide"}]}}
                };
                if (column.formatter == "custom" && uly.clientscripts[column.custom_formatter])
                    col.formatter = uly.clientscripts[column.custom_formatter];
                else if (column.formatter && uly.formatters[column.formatter])
                    col.formatter = uly.formatters[column.formatter];
                return col;
            }
            return null;
        });
        columns.splice(0,0, { "field":"", "id":"__rn", "cssClass":"fixed", "unselectable":true, "resizable":false, "sortable":false, "width":40, "name":"#", "formatter":uly.formatters.rownum });
        return columns;
    }
}
function _build_filter_expression(panel_filters) {
    var groups = [];
    var current_stack = [];
    if (panel_filters && !Array.isArray(panel_filters))
        panel_filters = [panel_filters];
    if (panel_filters) $.each(panel_filters, function(idx, val) {
        if (current_stack.length > 0 && val.operator == "or") {
            groups.push(current_stack);
            current_stack = [];
        }

        if (val.field && val.comparator) {
            var expr = val.field + " " + val.comparator + " ";
            var f1 = val.filter1;
            var f2 = val.filter2;
            if (val.comparator == "!~" && f1) {
                expr = "( " + val.field + " !~ " + ko.toJSON(f1) + " ) or ( " + val.field + " = null )";
                current_stack.push(expr);
            }
            else if (val.comparator != "><" && f1) {
                if (val.comparator == "in") {
                    if (f1) {
                        var toks = f1.map(function(v,idx) {
                            return ko.toJSON(v);
                        });
                        expr = expr +  "("+toks.join(",")+")";
                        current_stack.push(expr);
                    }
                }
                else
                {
                    expr = expr + ko.toJSON(f1);
                    current_stack.push(expr);
                }
            }
            else if (val.comparator == "><" && f1 && f2) {
                expr = "( " + val.field + " >= "+ko.toJSON(f1)+ " ) and ( " + val.field + " < " + ko.toJSON(f2) + " )";
                current_stack.push(expr);
            }
        }
    });
    if (current_stack.length > 0) {
        groups.push(current_stack);
    }
    var full_exp = false;
    $.each(groups, function(idx,group) {
        var subexp = "";
        $.each(group, function(idx2, filter) {
            if (idx2 > 0)
                subexp = "( " + subexp + " ) and ( " + filter + " )";
            else subexp = filter;
        });
        if (full_exp) {
            full_exp = "( " + full_exp + " ) or ( " + subexp + " )";
        }
        else full_exp = subexp;
    });
    return full_exp;
}

function _build_async_grid($gridElt, gridId, model, modelAccessor, columns, viewModel) {
    var search_url = model.server_url || (uly.root+"bsearch/"+(model.entity || ""));
    var dataview = new uly.ui.grid.RemoteSearchDataView(search_url, model, modelAccessor, columns, viewModel);
    var slickGrid = new Slick.Grid($gridElt, dataview.data, columns, {autoHeight:false, showHeaderRow:true, headerRowHeight:30, explicitInitialization:true, multiSelect:true, jQueryUiStyles: false});

    //new header menu

    var headerMenuPlugin = new Slick.Plugins.HeaderMenu({});
    headerMenuPlugin.onCommand.subscribe(function(e, data) {
        var columns = data.grid.getColumns();
        var index = $.inArray(data.column, columns);
        if (data.item.command =="hide" && index >= 0){
            columns.splice(index, 1);
            data.grid.setColumns(columns);

        }
    });

    slickGrid.registerPlugin(headerMenuPlugin);


    //end header menu

    slickGrid.get_dataview = function() { return dataview; };

    dataview.onDataRefreshed.subscribe(function(e,args) {
        if (null == slickGrid)
            return;
        var vp = slickGrid.getViewport();
        slickGrid.updateRowCount();
        slickGrid.invalidateRows();
        dataview.ensureData(vp.top, vp.bottom);
        slickGrid.render();
    });
    slickGrid.onViewportChanged.subscribe(function (e, args) {
        var vp = slickGrid.getViewport();
        dataview.ensureData(vp.top, vp.bottom);
        slickGrid.render();
    });
    return slickGrid;

}

function _build_sync_grid($gridElt, gridId, model, modelAccessor, columns, viewModel) {
    var dataview = new Crimson.ui.grid.LocalDataView();
    var slickGrid = new Slick.Grid($gridElt, dataview, columns, { autoHeight:false, showHeaderRow:true, headerRowHeight:30, explicitInitialization:true, jQueryUiStyles: false});
    slickGrid.get_dataview = function() { return dataview; };
    return slickGrid;
}

function _build_grid(element, model, griddata, viewModel, modelAccessor, bindingContext) {
    var columns = _build_grid_columns(model, model.user_settings != null);
    model._build_grid_columns = _build_grid_columns;
    var $gridElt = $(element);
    var $parent = $gridElt.parent();
    var gridId = $gridElt.attr("id");
    if (typeof gridId == "undefined" || !gridId) {
        gridId = "grid_1234";
        $gridElt.attr("id", gridId);
    }

    var slickGrid = null;
    var dataview = null;
    var grid_inited = Promise.Deferred();
    var columnFilters = {};
    if (model.async) {
        slickGrid = _build_async_grid($gridElt, gridId, model, modelAccessor, columns, viewModel);
    }
    else {
        slickGrid = _build_sync_grid($gridElt, gridId, model, modelAccessor, columns, viewModel);
    }
    dataview = slickGrid.get_dataview();

    dataview.onRowsChanged.subscribe(function() {
        grid_inited.resolve();
    });

    slickGrid.onSort.subscribe(function(e,args) {
        slickGrid.scrollRowToTop(0);
        slickGrid.setSelectedRows([]);
        dataview.setSort(args.sortCol, args.sortAsc);
    });

    dataview.onRowCountChanged.subscribe(function (e, args) {
        slickGrid.updateRowCount();
        slickGrid.render();
    });

    dataview.onRowsChanged.subscribe(function (e, args) {
        slickGrid.invalidateRows(args.rows);
        slickGrid.render();
    });

    dataview.onGetItemMetadata.subscribe(function(e,args) {
        if (null == slickGrid) return;
        var row = args.row;
        if (slickGrid.getSelectedRows().indexOf(row) >= 0) {
            args.metadata = { "cssClasses":"ui-state-highlight selected" };
        }
    });

    var col_filters = {};
    slickGrid.onHeaderRowCellRendered.subscribe(function(e, args) {
        $(args.node).empty();
        if (args.column.name != "#") {
            if (args.column.name != "#" && args.column.filter_control && args.column.filter_op) {
                var cntrl = Crimson.ui.grid.filters[args.column.filter_control];
                if (cntrl) {
                    cntrl(args, slickGrid, dataview, true, col_filters);
                }
            }
        }
        else {
            var _toggle = function(ev,ui)  {
                var val = $(ev.target).is(":checked") ? 1 : 0;
                if (val) {
                    slickGrid.getSelectionModel().setSelectedRanges([{ "fromRow":0, toRow: slickGrid.getDataLength(), "fromCell":0, "toCell":slickGrid.getColumns().length}]);
                }
                else {
                    slickGrid.getSelectionModel().setSelectedRanges([]);
                }
            };
            var cb = $("<input type='checkbox'></input>").css("z-index","9000").css("position","relative").attr("name", args.column.id).val(false).appendTo(args.node).change(_toggle).click(_toggle);
        }
    });
    var toggleRowSelection = function toggleRowSelection(row, force) {

        var srows = slickGrid.getSelectedRows();
        if (typeof force == "undefined") {
            if (srows.indexOf(row) >= 0) {
                slickGrid.setSelectedRows($.grep(srows, function (n) {
                    return n != row;
                }));
            } else {
                slickGrid.setSelectedRows(srows.concat(row));
            }
        }
        else if (force) {
            slickGrid.setSelectedRows(srows.concat(row));
        }
        else slickGrid.setSelectedRows($.grep(srows, function (n) {
            return n != row;
        }));

    };
    slickGrid.onClick.subscribe(function (e,ui) {
        var cell = slickGrid.getCellFromEvent(e);
        var column = slickGrid.getColumns()[cell.cell];
        var row_data = dataview.getItem(cell.row);
        if (column.name != "#") {
            //toggleRowSelection(cell.row, true);
            return grid_navigate(row_data);
        } else {
            toggleRowSelection(cell.row);
        }
    });

    slickGrid.setSelectionModel(new Crimson.ui.grid.RowSelectionModel());

    var grid_state_model = {
        selected_rows: ko.observableArray([]),
        active_row: ko.observable(null),
        reloadView: function() {
            dataview.refresh();
        }
    };
    $.extend(grid_state_model, {
        selected_row_count: ko.pureComputed(function() {
            return grid_state_model.selected_rows().length;
        }),
        selected_row_data: function() {
            var rows = grid_state_model.selected_rows();
            var to = Math.max.apply(null, rows);
            var from = Math.min.apply(null, rows);
            var deferred = Promise.Deferred();
            var compute = function() {
                var result = [];
                $.each(rows, function(idx,val) {
                    result.push(dataview.getItem(val));
                });
                deferred.resolve(result);
            };
            if (typeof dataview.ensureData == "function")
                dataview.ensureData(from,to).done(compute).fail(function(result) { deferred.reject(result); });
            else compute();
            return deferred.promise();
        }
    });

    //TODO: Refactor this for more general solution to bubbling up selection
    if (bindingContext && typeof bindingContext.selected_data == "function") {
        grid_state_model.selected_rows.subscribe(function(newvalue) {
            grid_state_model.selected_row_data().done(function(results) {
                bindingContext.selected_data(results);
            });
        });
    } else if (viewModel && typeof viewModel.selected_data == "function") {
        grid_state_model.selected_rows.subscribe(function(newvalue) {
            grid_state_model.selected_row_data().done(function(results) {
                viewModel.selected_data(results);
            });
        });
    }


    slickGrid.onSelectedRowsChanged.subscribe(function(e,args) {
        var rows = args.rows;
        grid_state_model.selected_rows(rows);
        for(var i = 0; i < args.rows.length; ++i)
        {
            var row = args.rows[i];
            var $fixed = $(slickGrid.getCellNode(row, 0));
            var $row = $fixed.parent();
            if (!$row.hasClass("marked")) {
                $row.addClass("marked");
            }
            $row.addClass("ui-state-highlight selected");
        }
        var $selected_rows = $gridElt.find(".slick-cell.selected").parent();
        var $marked_rows = $gridElt.find(".marked").not($selected_rows).removeClass("marked").removeClass("ui-state-highlight").removeClass("selected");
    });
    dataview.onDataRefreshed.subscribe(function(e,args) {
        if (!slickGrid) {
            console.error("null slickgrid. we have a problem");
            return;
        }
        grid_state_model.selected_rows(slickGrid.getSelectedRows());
    });

    slickGrid.onActiveCellChanged.subscribe(function(e,args) {
        grid_state_model.active_row(args.row);
    });

    var load_state = function grid_load_state() {
        var state = uly.history.get_state().data;
        if (typeof state[gridId+"_f"] != "undefined") {
            var cf = JSON.parse(state[gridId+"_f"]);
            $.each(cf, function(k,v) {
                if (k&&v) {
                    if (col_filters[k] && ko.isObservable(col_filters[k]))
                        col_filters[k](v);
                    else col_filters[k] =ko.observable(v);
                }
            });
        }
        dataview.refresh();
        if (typeof state[gridId+"_idx"] != "undefined" || typeof state[gridId+"_s"] != "undefined") {
            var row = state[gridId+"_idx"];
            var selection = state[gridId+"_s"];
            grid_inited.done(function() {
                slickGrid.scrollRowToTop(1*row);
                if (selection) {
                    slickGrid.setSelectedRows(selection);
                    slickGrid.invalidate();
                }
            });
        }
    };

    var save_state = function grid_save_state() {
        try {
            var selected_rows = grid_state_model.selected_rows();
        }
        catch(e) {
            return;
        }
        var active_row = grid_state_model.active_row();
        Crimson.url.removeStateBit(gridId+"_s");
        Crimson.url.removeStateBit(gridId+"_idx");
        if (selected_rows.length > 0) {
            var sr = active_row || selected_rows[0];
            if (sr > 0)
                Crimson.url.rememberStateBit(gridId+"_idx", sr);
            if (selected_rows.length > 0)
                Crimson.url.rememberStateBit(gridId+"_s", selected_rows);

        }
        else if (active_row >= 0)
            Crimson.url.rememberStateBit(gridId+"_idx", active_row);

        var filter_state = ko.toJSON(col_filters);//dataview.getFilterState();
        var f = filter_state;//$.param(filter_state);
        if (f && f.length > 0)
            Crimson.url.rememberStateBit(gridId+"_f", f);
        else Crimson.url.removeStateBit(gridId+"_f");
    };

    $(document).bind("state:load", load_state).bind("state:save", save_state);
    var reload_view = function() {
        $gridElt.trigger("grid:refresh");
    };

    uly.subscribe("view.reload", reload_view, $gridElt[0]);
    ko.utils.domNodeDisposal.addDisposeCallback($gridElt[0], function(){
        uly.unsubscribe(reload_view);
        $(document).unbind("state:load", load_state).unbind("state:save", save_state);
        if ($parent) {
            $parent.unbind("resize");
            $parent = null;
        }
        var sel_model = slickGrid.getSelectionModel();
        sel_model.destroy();
        slickGrid.destroy();
        slickGrid = null;
        dataview = null;
        $gridElt.data("slickgrid", null);
        $gridElt.data("slickview", null);
    });
    $gridElt.data("slickgrid", slickGrid).data("slickview", dataview);
    var in_search_dialog = $.koVal(model.in_search);
    if (in_search_dialog) {
        var $dialog = $gridElt.closest(".ui-dialog");
    }
    var grid_navigate  = function(row_data) {

        //Crimson.url.rememberStateBit(gridId+"_idx", row_data.index);
        //Crimson.url.commitState().done(function() {

        var data = $.extend({}, row_data);
        if (in_search_dialog) {
            typeof viewModel.grid_selected_data == "function" && viewModel.grid_selected_data(data);
            var sdata = {"row_data":data };
            sdata["element"] = $gridElt;
            //sdata["selected_rows"] = grid_state_model.selected_row_data();
            $gridElt.trigger("action:search_select", sdata);
            return;
        }

        var action = $gridElt.data("action");
        var link = data["__link"];
        if (typeof action == "string" && action)
        {
            console.log("navigating: ", action, link, data);
            $gridElt.trigger("action:"+action, data);
        }
        else if (model.editable)
        {
            //todo: editable grid
            var editButton = $("#"+$(element).attr("id")+"_iledit");
            if (!editButton.hasClass("ui-state-disabled"))
                editButton.click();
            else {
                var saveButton = $("#"+$(element).attr("id") + "_ilsave");
                if (!saveButton.hasClass("ui-state-disabled"))
                {
                    saveButton.click();
                    //if (!editButton.hasClass("ui-state-disabled"))
                    //        editButton.click();
                }
            }
        }
        else
        {
            var lformat = model["linkformat"];
            if (typeof lformat != "undefined " && lformat) {
                var lk = lformat.replace("##__link##", data["__link"]).replace("##id##", data["id"]);
                data["__link"] = lk;
            }
            data.bindingContext = bindingContext;
            data.modelData = {"id":data.id};
            console.log("navigating:", data, data.modelData, model, model.action);
            if (model.action && model.action != "navigateto")
                $(element).trigger("action:"+model.action, data);
            else
                uly.actions.navigateto(data["__link"], $(element), data);
        }
    };

    var is_dialog = $gridElt.closest(".crimson-dialog").length > 0;
    var initialise_grid = function() {
        var $pager = $(element).prev();
        var pager = new Slick.Controls.SearchPager(dataview, slickGrid, $pager, model, grid_state_model, bindingContext, viewModel);
        //Crimson.ui_theme.maximize_height($gridElt, 150, $pager, 40);
        /*
          $gridElt.adapt({offset_elements:$pager}).bind(
          "refresh", function(){
          if (model.async)
          slickGrid.onViewportChanged.notify();//$gridElt.trigger("grid:refresh");
          return false;
          }
          );
        */
        slickGrid.init();
        // load the first page
        if (model.async)
            slickGrid.onViewportChanged.notify();
        slickGrid.resizeCanvas();
        setTimeout(function() {
            var parentTab = $gridElt.closest(".ui-tabs-panel");
            var parentTabControl = $gridElt.closest(".ui-tabs");
            var has_resized = false;


            var _refreshfunc = function() { dataview.refresh(); grid_state_model.selected_rows(slickGrid.getSelectedRows()); };
            $gridElt.unbind("grid:refresh").bind("grid:refresh", _refreshfunc);
            if (parentTabControl.length > 0) {
                /*
                  Crimson.view.subscribe(parentTabControl, "tab:activated", function(){
                  if (parentTab.is(":visible") && !has_resized) {
                  $gridElt.trigger("grid:refresh")
                  }
                  });


                  parentTabControl.bind("tabsactivate", function(ev,ui) {
                  if (parentTab.is(":visible") && !has_resized) {
                  //Crimson.ui_theme.maximize_height($gridElt, 150, $pager, 40);
                  var g = $gridElt.data("slickgrid");
                  g.updateRowCount();
                  g.resizeCanvas();
                  g.invalidate();
                  g.render();
                  has_resized = true;
                  }
                  });
                */
            }
            else
            {
                var dialog = $gridElt.closest(".crimson-dialog");
                if (dialog.length > 0)
                {
                    //Crimson.ui_theme.maximize_height($gridElt, 150, $pager, 40);
                    var g = $gridElt.data("slickgrid");
                    g.resizeCanvas();
                    g.invalidate();
                    //g.render();
                    //dialog.dialog('open');
                    has_resized = true;
                }
            }

            //$(document).bind("view:reload", _refreshfunc);
            ko.utils.domNodeDisposal.addDisposeCallback($gridElt[0], function(){
                $gridElt.unbind("grid:refresh");
                $(document).unbind("view:reload",_refreshfunc);
                _refreshfunc = null;
            });
            // grid_inited.resolve();
        }, 0);

    };
    if (is_dialog) {
        window.setTimeout(initialise_grid, 0);
    }
    else
        initialise_grid();

    return slickGrid;
}

if ($.ui) {


    ko.bindingHandlers.withgridsettings = {
        init: function(element, modelAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var model = ko.utils.unwrapObservable(modelAccessor().model);
            var id = ko.utils.unwrapObservable(modelAccessor().id);
            var context = bindingContext.extend(model);
            ko.applyBindingsToDescendants(context, element);
            return { "controlsDescendantBindings": true };

        }
    };
    ko.virtualElements.allowedBindings.withgridsettings = true;
    ko.bindingHandlers.jqgrid = {
        init: function(element, modelAccessor, allBindingsAccessor, viewModel, bindingContext) {
            console.log("initialising grid:", arguments);
            var model = ko.utils.unwrapObservable(modelAccessor());
            var dataAccessor = allBindingsAccessor().griddata;
            //hack to get the rest of the code working.
            if (!viewModel) viewModel = {};

            if (typeof dataAccessor == "undefined")
                var data = null;
            else
                var data = ko.utils.unwrapObservable(dataAccessor);
            if (typeof model == "undefined" || model == null)
            {
                if (Array.isArray(data) && data.length > 0) {
                    model = data[0][$(element).attr("id") + "_grid_model"];
                }
            }
            //ok we've got our grid model. clone it and add the filtering crap to it.
            //var _model = $.extend({}, model);
            var _model = ko.toJS(model);
            var _modelAccessor = function() { return _model; };
            var is_dialog = $(element).closest(".crimson-dialog").length > 0;

            model = _model;

            var orig_filters = _model.filters;
            if (typeof _model.filter_panel == "undefined") _model.filter_panel = {};
            if (typeof _model.filter_panel.values != "function")
                _model.filter_panel.values = ko.observableArray(_model.filter_panel.values || []);
            _model.filters = ko.pureComputed(function() {
                var panel_filters = ko.toJS(_model.filter_panel).values;//.filter_panel.values);
                var normal_filters = ko.toJS(orig_filters) || [];
                if (!Array.isArray(normal_filters))
                    normal_filters = [normal_filters];
                var panel_filter_expression = _build_filter_expression(panel_filters);
                if (panel_filter_expression)
                    normal_filters.push(panel_filter_expression);
                return normal_filters;
            });
            _model.filters.subscribe(function(nv) { console.log("filters subscription triggered: ", nv, _model.filters()); });
            console.log("building grid with model: ", _model);
            $(element).addClass("slickgrid");
            var grid = _build_grid($(element), _model, data, viewModel, _modelAccessor, bindingContext);
            var dataview = grid.get_dataview(), columns = grid.getColumns();
            if (_model.sort_column != null){
                var column = grid.getColumns()[grid.getColumnIndex(_model.sort_column)];
                if (column){
                    dataview.setSort(column, _model.sort_order);
                    grid.setSortColumn(column.id, _model.sort_order);
                }
            }
            return { controlsDescendantBindings: true };
        }
    };

    ko.bindingHandlers.filterpanel = {
        init: function(element, va, allBindingsAccessor, viewModel, context) {
            var grid_model = ko.utils.unwrapObservable(va());
            /*
            if (typeof grid_model._panel == "undefined")
            grid_model._panel = grid_model.panel;
            else
            grid_model.panel = grid_model._panel;
            */
            grid_model.panel = Crimson.view.createModel(grid_model.panel, false);
            try {
                var filtervals = JSON.parse((Crimson.url.get_fragment_parameters() || {}).fp || {});
            }
            catch(e)
            {
                var filtervals = {};
            }
            Crimson.model.applyUpdatedModelAtPoint(filtervals, null, null, grid_model.panel);
            /*
            $.each(Crimson.url.get_fragment_parameters(), function(key,value) {
            if (typeof grid_model.panel[key] == "function")
            grid_model.panel[key](value);
            });
            */
            ko.applyBindingsToDescendants(grid_model.panel, element);
            return {"controlsDescendantBindings":true };
        },
        oupdate: function(element, va, allBindingsAccessor, viewModel, context) {
            var grid_model = ko.utils.unwrapObservable(va());
            var new_accessor = function() { return grid_model.panel; };
            return ko.bindingHandlers["with"].update(element,new_accessor,allBindingsAccessor,viewModel, context);
        }
    };
    ko.bindingHandlers.griddata = {
        update: function(element, dataAccessor, allBindingsAccessor, viewModel) {
            var data = ko.utils.unwrapObservable(dataAccessor());
            var modelAccessor = allBindingsAccessor().jqgrid;
            var model = null;
            if (typeof modelAccessor == "undefined" || ko.utils.unwrapObservable(modelAccessor) == null)
            {
                if (Array.isArray(data) && data.length > 0)
                {
                    var fd = data[0];
                    var model_key = $(element).attr("id") + "_grid_model";
                    model = fd[model_key];
                    if (typeof model == "undefined")
                        model = null;
                }
            }
            else model = ko.utils.unwrapObservable(modelAccessor);

            if (model)
            {
                if (ko.utils.unwrapObservable(model.async))
                    return;
                var $grid = $(element);
                var gridId = $grid.attr("id") || "grid";
                if (ko.isObservable(data))
                    data = ko.utils.unwrapObservable(data);

                var grid_data = ko.toJS(data) || [];
                var idfield = ko.utils.unwrapObservable(model.idfield) || "id";
                $.each(grid_data, function(k,v) {
                    //if (typeof v.__record_data == "undefined")
                    //        v.__record_data = ko.toJSON(v);
                    if (typeof v.id == "undefined" || v.id == null)
                        v.id = v[idfield];
                    $.each(v, function(k,vv) {
                        if (vv instanceof Date) {
                            v[k] = Crimson.utils.formatDateTime(vv);
                        }
                    });
                });
                var slickview = $grid.data("slickview");
                slickview.setItems(grid_data);
                var slickGrid = $grid.data("slickgrid");
                //slickGrid.setData(grid_data);
                slickGrid.resizeCanvas();
            }
            slickGrid.resizeCanvas();
        }
    };

    ko.bindingHandlers.copy_grid_model = {
        "init":function(element, va, allBindings, viewModel, context) {
            var model = ko.toJS(va());
            if (model.panel) {
                $.each(Crimson.url.get_fragment_parameters(), function(key,value) {
                    if (typeof model.panel[key] != "undefined")
                        model.panel[key] = value;
                });
            }
            var new_model = Crimson.model.createViewModel(model, true);
            context = context.extend({"local_grid_model":new_model });
            ko.applyBindingsToDescendants(context, element);
            return {"controlsDescendantBindings":true};
        }
    };

    ko.virtualElements.allowedBindings.copy_grid_model = true;
    $(document).bind("action:actAddInline", function(ev,data) {
        var $button = $(ev.target);
        var $c = $button.parent();
        var $grid = null;
        while ($grid == null || $grid.length <= 0) {
            $grid = $c.find("table.ui-jqgrid-btable");
            if ($grid.length > 0)
                break;
            $c = $c.parent();
        }
        if ($grid && $grid.length > 0) {
            $grid.jqGrid("editRow", "new",true, false, false, "clientArray", false);
        }
    });

}